// Helper: แปลง child condition แต่ละอันให้เป็น expression clause
function transformSubjectConstraint(child) {
    // ดึงชื่อ attribute จาก l_operand (ถ้าเป็น object ให้ใช้ .name)
    const attributeName =
        typeof child.l_operand === 'object' && child.l_operand.name
            ? child.l_operand.name
            : child.l_operand;

    const clause = {
        l_operand: { subject_attr: attributeName },
        operator: child.operator,
        r_operand: { const: child.r_operand }
    };

    return clause;
}

function transformGroupConditions(subjectConstraints) {
    if (!subjectConstraints || subjectConstraints.length === 0) return null;

    const conjunctions_count = countConjunctions(subjectConstraints); // ["AND", "OR", null, "AND"]

    const expressions_count = subjectConstraints.map(cond => {
        return transformSubjectConstraintChild(cond.child); // [{l_operand: { subject_attr: "name" }, operator: "==", r_operand: { const: "value" } }]
    });
    const expression_group = checkGroupExpression(expressions_count);

    if (checkConsistency(conjunctions_count)) { // ตรวจสอบว่าเป็น AND หรือ OR ทั้งหมดหรือไม่
        return {
            conjunction: conjunctions_count[0],
            group: false,
            condition: expression_group
        };
    } else {
        let currentConjunction = conjunctions_count[0];
        let exp = {
            conjunction: conjunctions_count[0],
            group: false,
            condition: [expression_group[0]]
        };
        let subjectConstraints_count = exp.condition;
        for (let i = 0; i < conjunctions_count.length; i++) {
            if (currentConjunction !== conjunctions_count[i]) { // กรณีที่ conjunction เปลี่ยน "AND" => "OR" หรือ "OR" => "AND"
                if (conjunctions_count[i] === null) {
                    return exp;
                } else {
                    currentConjunction = conjunctions_count[i];
                    subjectConstraints_count = [{ ...exp }];
                    subjectConstraints_count.push(expression_group[i + 1]);
                    exp = {
                        conjunction: conjunctions_count[i],
                        group: false,
                        condition: subjectConstraints_count
                    };
                }
            } else { // กรณีที่ conjunction เดิมยังคงอยู่
                subjectConstraints_count.push(expression_group[i + 1]);
                exp = {
                    conjunction: conjunctions_count[i],
                    group: false,
                    condition: subjectConstraints_count
                }
            }
        }
        return exp;
    }
}

function checkGroupExpression(expression) {
    const expression_checked = expression.map((exp) => {
        if (exp.condition && exp.condition.length > 1) {
            return { ...exp, group: true };
        } else {
            return exp;
        }
    });
    return expression_checked;
};

function transformSubjectConstraintChild(child) {
    if (!child || child.length === 0) return null;
    if (child.length === 1) return transformSubjectConstraint(child[0]);

    const conjunctions_count = countConjunctions(child); // ["AND", "OR", null, "AND"]
    // console.log("Count Conjunctions:", conjunctions_count);
    const expressions_count = countExpressions(child); // [{l_operand: { subject_attr: "name" }, operator: "==", r_operand: { const: "value" } }]
    // console.log("Count Expressions:", expressions_count);

    if (checkConsistency(conjunctions_count)) { // ตรวจสอบว่าเป็น AND หรือ OR ทั้งหมดหรือไม่
        return {
            conjunction: conjunctions_count[0],
            group: false,
            condition: expressions_count
        };
    } else {
        let currentConjunction = conjunctions_count[0];
        let exp = {
            conjunction: conjunctions_count[0],
            group: false,
            condition: [expressions_count[0]]
        };
        let subjectConstraints_count = exp.condition;
        for (let i = 0; i < conjunctions_count.length; i++) {
            if (currentConjunction !== conjunctions_count[i]) { // กรณีที่ conjunction เปลี่ยน "AND" => "OR" หรือ "OR" => "AND"
                if (conjunctions_count[i] === null) {
                    return exp;
                } else {
                    currentConjunction = conjunctions_count[i];
                    subjectConstraints_count = [{ ...exp }];
                    subjectConstraints_count.push(expressions_count[i + 1]);
                    exp = {
                        conjunction: conjunctions_count[i],
                        group: false,
                        condition: subjectConstraints_count
                    };
                }
            } else { // กรณีที่ conjunction เดิมยังคงอยู่
                subjectConstraints_count.push(expressions_count[i + 1]);
                exp = {
                    conjunction: conjunctions_count[i],
                    group: false,
                    condition: subjectConstraints_count
                }
            }
        }
        return exp;
    }
}

function countConjunctions(subjectConstraints) {
    const conjunctions = subjectConstraints.map(child => {
        if (child.conjunction === "") {
            return null;
        } else {
            return child.conjunction;
        }
    });
    return conjunctions
}

function checkConsistency(arr) {
    const hasAND = arr.includes('AND');
    const hasOR = arr.includes('OR');
    return !(hasAND && hasOR);
}

function countExpressions(child) {
    const expressions = child.map(cond => {
        return transformSubjectConstraint(cond);
    });
    return expressions
}

function transformSubjectConstraintsToExpression(subjectConstraints) {
    if (!subjectConstraints || subjectConstraints.length === 0) return {};

    if (subjectConstraints.length === 1) {
        const expression = transformSubjectConstraintChild(subjectConstraints[0].child);
        return expression;
    } else {
        const transform_group_subjectConstraints = transformGroupConditions(subjectConstraints);
        return transform_group_subjectConstraints;
    }
}

export default transformSubjectConstraintsToExpression;